/** App versions are dotted numbers: "1.4.0", "2.0" (1 to 4 parts). */
export const VERSION_RE = /^\d{1,6}(\.\d{1,6}){0,3}$/;

/** Numeric comparison of dotted versions ("1.10.0" > "1.9.2"); missing parts count as 0. Invalid input sorts lowest. */
export function compareVersions(a: string, b: string): number {
  const pa = VERSION_RE.test(a) ? a.split('.').map(Number) : [-1];
  const pb = VERSION_RE.test(b) ? b.split('.').map(Number) : [-1];
  for (let i = 0; i < Math.max(pa.length, pb.length); i++) {
    const d = (pa[i] ?? 0) - (pb[i] ?? 0);
    if (d) return d < 0 ? -1 : 1;
  }
  return 0;
}
